import React from 'react';

import { FieldInfoGroupField } from '@app/common/configurable-wizards';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { isFieldInfoGroupField } from '@app/common/configurable-wizards/utils';

import { ProfileDetailsFields } from '@app/widgets/contacts-and-settings/types';

import { SecurityList } from './Security/SecurityList';
import { UserProfileList } from './UserProfile/UserProfileList';

export const ProfileAndSecurityFieldsList: FieldComponent<FieldInfoGroupField> = (props) => (
  <>
    <UserProfileList />
    <SecurityList {...props} />
  </>
);

export const ProfileAndSecurityFieldsListLocator: FieldLocator = ({ field }) => (
  isFieldInfoGroupField(field) && field.id in ProfileDetailsFields
    ? ProfileAndSecurityFieldsList
    : undefined
);
